import './header.scss'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from '../../store/builders/auth/auth.builders.js'
import logoutIcon from '../../assets/icons/logout.svg'

const Header = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = () => {
    dispatch(logout({ navigate }))
  }

  return (
    <div className='header-container flex justify-end align-center'>
      {/* <img className='header-icon' src={notificationIcon} />
      <img className='header-icon' src={settingIcon} /> */}
      <div className='vertical-line'></div>
      <div onClick={handleLogout} className='header-logout flex justify-center align-center'>
        <img src={logoutIcon} />
       <p className='logout-txt'>Log Out</p> 
      </div>
    </div>
  )
}

export default Header
